var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorShieldCheckmark240)",
    d: "M3 5.75A.75.75 0 0 1 3.75 5c2.663 0 5.258-.943 7.8-2.85a.75.75 0 0 1 .9 0C14.992 4.057 17.587 5 20.25 5a.75.75 0 0 1 .75.75V11c0 5.001-2.958 8.676-8.725 10.948a.75.75 0 0 1-.55 0C5.958 19.676 3 16 3 11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorShieldCheckmark241)",
    fillOpacity: 0.5,
    d: "M3 5.75A.75.75 0 0 1 3.75 5c2.663 0 5.258-.943 7.8-2.85a.75.75 0 0 1 .9 0C14.992 4.057 17.587 5 20.25 5a.75.75 0 0 1 .75.75V11c0 5.001-2.958 8.676-8.725 10.948a.75.75 0 0 1-.55 0C5.958 19.676 3 16 3 11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorShieldCheckmark242)",
    d: "M17.5 12a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorShieldCheckmark243)",
    fillRule: "evenodd",
    d: "M20.854 15.146a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708l1.646 1.647l3.646-3.647a.5.5 0 0 1 .708 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorShieldCheckmark240",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.64308 38.74988 -34.23049 24.41907 -4.072 -9.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0fafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#367af2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#5750e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#cc23d1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorShieldCheckmark241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 8.125 -8.35714 0 17.786 18.875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e1868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1868",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorShieldCheckmark242",
    x1: 12.393,
    x2: 19.984,
    y1: 14.063,
    y2: 21.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d17c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22918b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorShieldCheckmark243",
    x1: 15.313,
    x2: 16.45,
    y1: 15.51,
    y2: 21.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3ffd9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity2);
export default __webpack_public_path__ + "static/media/community2.1d0c4e4e177f7a02a50ef697ef8d8f88.svg";
export { ForwardRef as ReactComponent };